module.exports = __webpack_public_path__ + "static/media/IMG_9008.7696165f.jpg";